export default "__VITE_ASSET__DCUag60N__"